import React, { useCallback, useEffect, useState } from 'react'
import { ModalBody, ModalWrapper } from './SelectGroupPopupStyled'
import { inject, observer } from 'mobx-react'
import SelectGroupBox from './SelectGroupBox'
import { Button, message, Popconfirm, Select, Space, Tag, Tooltip } from 'antd'
import {
  CloseOutlined,
  TeamOutlined,
  UnorderedListOutlined,
  WarningOutlined,
} from '@ant-design/icons'
import { ASSIGNEE_TYPE } from '../../constants'
import './SelectGroupPopupStyled'
// import { EmptyText } from '../common/CellText'
import EmptyContent from './../common/EmptyContent/EmptyContent'
import { AvatarHasName } from '../common/Avatar'
const { Option } = Select

const SelectGroupPopup = props => {
  const {
    isVisibleSelectGroupPopup,
    handleSubmitSelectGroup,
    handleCancelSelectGroup,
    selectPeopleStore,
    // clearSelectGroup,
    // loadingAnimationStore,
    groupType,
    onlySelectOne,
    noLoadSelectData,
    authenticationStore,
    companyStore,
  } = props

  const {
    assigneePopupType,
    selectGroupData,
    setSelectGroupData,
    setGroupList,
    originGroupList,
    companyCode,
  } = selectPeopleStore
  const { companyList } = companyStore

  const [disableGroupList, setDisableGroupList] = useState([])

  const [isLoading, setIsLoading] = useState(false)
  const [prevSelectedGroupData, setPrevSelectedGroupData] = useState([])

  const handleRemoveSelect = useCallback(
    group => {
      setSelectGroupData({
        ...selectGroupData,
        [assigneePopupType]: selectGroupData[assigneePopupType].filter(
          el => el.id !== group.id
        ),
      })
    },
    [assigneePopupType, selectGroupData]
  )

  useEffect(() => {
    setPrevSelectedGroupData(selectGroupData[assigneePopupType])
  }, [isVisibleSelectGroupPopup])

  useEffect(() => {
    if (!assigneePopupType) return
    const selectedGroupList = [
      ...selectGroupData[ASSIGNEE_TYPE.LEADER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.COMBINER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ]
    setDisableGroupList(
      selectedGroupList
        .filter(el => el.permission !== assigneePopupType)
        .map(el => el.id)
    )
  }, [assigneePopupType])

  useEffect(() => {
    setGroupList(originGroupList)
  }, [isVisibleSelectGroupPopup])

  useEffect(() => {
    if (noLoadSelectData) return
    ;(async () => {
      if (companyCode) {
        if (authenticationStore.currentUser) {
          try {
            setIsLoading(true)
            await selectPeopleStore.getGroupList(
              groupType,
              authenticationStore.currentCompanyCode()
            )
          } catch (err) {
            console.log(err)
            message.error(err.vi || 'Đã có lỗi xảy ra!')
          } finally {
            setIsLoading(false)
          }
        }
      }
    })()
  }, [companyCode])

  useEffect(() => {
    if (authenticationStore.currentUser) {
      selectPeopleStore.companyCode = authenticationStore.currentCompanyCode()
    }
  }, [authenticationStore.currentUser])

  const handleSelectChange = e => {
    selectPeopleStore.companyCode = e.target.value
  }

  return (
    <ModalWrapper
      maskClosable={false}
      okText={'Đồng ý'}
      cancelText={'Hủy bỏ'}
      width={700}
      footer={null}
      style={{ top: 20 }}
      zIndex={100000}
      title={
        <div
          style={{
            alignItems: 'center',
          }}>
          <div
            style={{
              display: 'flex',
              margin: '10px 0',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
            {/* <Popconfirm
              placement="top"
              zIndex={100000}
              title={'Bạn có chắc chắn muốn xóa hết người được chọn không ?'}
              onConfirm={() =>
                // clearSelectGroup
                //   ? clearSelectGroup()
                //   : handleCancelSelectGroup()

                {
                  selectPeopleStore.handleRemoveSelectGroup()
                }
              }
              okText="Đồng ý"
              cancelText="Không"> */}
            <Button
              danger
              style={{ display: 'flex', alignItems: 'center' }}
              icon={<WarningOutlined style={{ color: '#fa8c16' }} />}
              onClick={() => {
                selectPeopleStore.handleRemoveSelectGroup()
              }}>
              Hủy chọn
            </Button>
            {/* </Popconfirm> */}
            {/* <Popconfirm> */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Button
                style={{
                  backgroundColor: ' #1677ff',
                  color: '#fff',
                  boxShadow: ' 0 2px 0 rgba(5, 145, 255, 0.1)',
                }}
                onClick={() => {
                  JSON.stringify(selectGroupData[assigneePopupType]) !==
                  JSON.stringify(prevSelectedGroupData)
                    ? handleSubmitSelectGroup()
                    : handleCancelSelectGroup()
                }}>
                Đồng ý
              </Button>
              {/* </Popconfirm> */}

              {/* <Tooltip title={'Đóng'}> */}
              <Button
                style={{
                  display: 'flex',
                  backgroundColor: 'red',
                  color: '#fff',
                  alignItems: 'center',
                }}>
                <CloseOutlined
                  onClick={() => {
                    setSelectGroupData({
                      ...selectGroupData,
                      [assigneePopupType]: prevSelectedGroupData,
                    })
                    handleCancelSelectGroup()
                  }}
                />
              </Button>
            </div>
            {/* </Tooltip> */}
          </div>
          <select
            style={{
              color: companyCode === '' ? 'rgb(161 169 179)' : 'black',
              width: '100%',
              WebkitAppearance: 'none',
              padding: '5px',
              outline: 'none',
              borderRadius: '5px',
              border: '1.5px solid #d9d9d9',
              overflow: 'hidden',
              fontSize: 10,
            }}
            onChange={handleSelectChange}
            value={companyCode}
            placeholder={'-- Chọn công ty --'}>
            {companyList.map(item => (
              <option
                style={{ width: '100px', wordWrap: 'break-word' }}
                key={item.code}
                value={item.code}>
                <span>{item.name}</span>
              </option>
            ))}
          </select>
        </div>
      }
      closable={false}
      forceRender={true}
      open={isVisibleSelectGroupPopup}>
      <ModalBody>
        <div className={'list-box m-1'}>
          <label
            style={{
              width: 90,
              display: 'flex',
              alignItems: 'center',
              fontWeight: 500,
            }}>
            <UnorderedListOutlined
              style={{ marginRight: 4, color: '#2C65AC' }}
            />
            Danh sách:
          </label>
          {assigneePopupType &&
          selectGroupData[assigneePopupType].length > 0 ? (
            selectGroupData[assigneePopupType].map(el => {
              return (
                <Tag
                  className={'tag-selected'}
                  color={'#2C65AC'}
                  key={el.id}
                  closable
                  onClose={() => handleRemoveSelect(el)}>
                  <AvatarHasName
                    imgId={el.image_id}
                    size={22}
                    name={el.full_name}
                    icon={
                      el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                        <TeamOutlined />
                      )
                    }
                  />
                </Tag>
              )
            })
          ) : (
            <div>
              <span style={{ lineHeight: '34px' }}>
                Chưa có nhóm nào được chọn
              </span>
            </div>
          )}
        </div>
        <div className={'modal-body'} style={{ position: 'relative' }}>
          <SelectGroupBox
            disableGroupList={disableGroupList}
            onlySelectOne={onlySelectOne}
            isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
          />
          {/* <SpinnerInlineComponent
            sizeSpin={'small'}
            isLoading={isLoading}
            noBackground
          /> */}
          <div />
        </div>
      </ModalBody>
    </ModalWrapper>
  )
}

SelectGroupPopup.propTypes = {}

export default inject(
  'selectPeopleStore',
  // 'loadingAnimationStore',
  'authenticationStore',
  'companyStore'
)(observer(SelectGroupPopup))
